import {
  ArrowUDownLeftIcon,
  ChartLineIcon,
  CoinsIcon,
  GearIcon,
  HouseIcon,
  PackageIcon,
  SquaresFourIcon,
} from '@phosphor-icons/react'

import routes from '@/Router/routes.constants'

import { categories } from './constants'

export const filterSettings = (settings, query, t) => {
  if (!query) return []
  const lowerQuery = query.toLowerCase()
  return settings.filter(setting => {
    const translated = t(setting.translationKey).toLowerCase()
    const original = setting.translationKey.toLowerCase()
    return translated.includes(lowerQuery) || original.includes(lowerQuery)
  })
}

export const getShipmentCustomerName = shipment => {
  const firstName = shipment.customer_profile?.first_name || ''
  const lastName = shipment.customer_profile?.last_name || ''
  return `${firstName} ${lastName}`.trim()
}

export const formatParcelResult = parcel => ({
  id: parcel.id,
  title: parcel.order.name || parcel.id,
  subtitle: getShipmentCustomerName(parcel),
  status: parcel.status,
  path: routes.parcelDetailPage.replace(':id', parcel.id),
  category: categories.shipments,
})

export const formatReturnResult = returnItem => ({
  id: returnItem.id,
  title: returnItem.order?.name || returnItem.id,
  subtitle: returnItem.customer?.name || '',
  status: returnItem.status,
  path: `/transactions/${returnItem.id}`,
  category: categories.returns,
})

export const formatSettingResult = (setting, t) => ({
  id: setting.path,
  title: t(setting.translationKey),
  subtitle: '',
  path: setting.path,
  category: categories.settings,
  Icon: setting.Icon,
})

export const getQuickLinks = ({ allowsShipments, allowsUnifiedDashboard }) => [
  ...(allowsUnifiedDashboard
    ? [
        { translationKey: 'Inicio', path: '/merchant-dashboard', Icon: HouseIcon },
        {
          translationKey: 'Transacciones',
          path: '/merchant-transactions?returnsCursor=null',
          Icon: ArrowUDownLeftIcon,
        },
        { translationKey: 'Configuración global', path: '/merchant-config', Icon: GearIcon },
      ]
    : []),
  { translationKey: 'Dashboard', path: '/', Icon: SquaresFourIcon },
  { translationKey: 'Transacciones', path: '/transactions?returnsCursor=null', Icon: ArrowUDownLeftIcon },
  ...(allowsShipments ? [{ translationKey: 'Envíos', path: '/parcels?shipmentsCursor=null', Icon: PackageIcon }] : []),
  { translationKey: 'Métricas', path: '/analytics', Icon: ChartLineIcon },
  { translationKey: 'Facturas', path: '/billing', Icon: CoinsIcon },
  { translationKey: 'Configuración', path: '/config/store', Icon: GearIcon },
]
